<ng-container *ngIf="loading">
  <div class="page">
    <app-object [object]="object" [editMode]="editMode"></app-object>
    <router-outlet></router-outlet>
  </div>
</ng-container>
<ng-container *ngIf="!loading">
  <div class="loading"></div>
</ng-container>
